<template>
    <section class="page16">
        <div class="top-image index-0">
            <img src="~@/assets/img/section-bot.png" alt="" />
        </div>
        <p class="title text-bold" data-aos="fade-up">
            Como a gente pode ajudar você nesse momento?
        </p>
        <p data-aos="fade" data-aos-delay="300">
            A LG lugar de gente já está de olho na LGPD há muito tempo. Isso
            porque prezamos por garantir que os nossos sistemas também atendam
            requisitos legais. Conheça abaixo quais soluções da LG lugar de
            gente são impactadas pela LGPD e como elas contribuem para o
            atendimento das normas.
        </p>
        <!-- <div class="video"><iframe src="https://player.vimeo.com/video/226053498" width="100%" height="100%" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe></div> -->
        <div class="embed-container" data-aos="fade" data-aos-delay="500">
            <iframe
                src="https://player.vimeo.com/video/488098816"
                frameborder="0"
                webkitAllowFullScreen
                mozallowfullscreen
                allowFullScreen
            ></iframe>
        </div>
    </section>
</template>

<script>
export default {
    data() {
        return {};
    },
    methods: {},
};
</script>

<style lang="scss" scoped>
.page16 {
    position: relative;
    background-image: url("~@/assets/img/sectionred-bg.png");
    background-position-x: right;
    background-size: contain;
    background-color: #911717;
    background-repeat: no-repeat;
    min-height: 580px;
    padding-top: 40px;
    padding-bottom: 40px;
    color: #fff;

    p {
        max-width: 820px;
        margin: 0 auto;
        font-size: 0.9rem;
        margin-bottom: 30px;
    }
    .title {
        font-size: 2.7rem;
        margin-bottom: 15px;
    }
    .top-image {
        top: -102px;
        img {
            height: 100%;
        }
    }
    .video {
        width: 100%;
        max-width: 640px;
        height: 360px;
        margin: 0 auto;
    }
    .embed-container {
        position: relative;
        margin: 0 auto;
        padding-bottom: 36.25%;
        height: 0;
        overflow: hidden;
        max-width: 75%;
    }

    .embed-container iframe,
    .embed-container object,
    .embed-container embed {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

    @media (max-width: 1000px) {
        padding-left: 20px;
        padding-right: 20px;
        .embed-container {
            position: relative;
            margin: 0 auto;
            padding-bottom: 90.25%;
            height: 0;
            overflow: hidden;
            max-width: 100% !important;
        }
    }
}
</style> 